import { Button } from "antd";
import ConfettiExplosion from "react-confetti-explosion";
import { useTranslation } from "react-i18next";

import { NAMESPACES } from "@/constants/i18next.constants";

import { useBillingOnboardingStore } from "../../BillingOnboardingModal.store";
import {
  ContentContainer, Figure, HeroImg, LogoStyled,
  ResultText,
} from "./FormResult.styles";

function FormResult() {
  const { t } = useTranslation([NAMESPACES.BILLING_ONBOARDING, NAMESPACES.COMMON]);

  const toggleModal = useBillingOnboardingStore(state => state.toggleModal);

  const handleOnClose = () => {
    toggleModal();
  };

  return (
    <>
      <Figure>
        <HeroImg
          src={
            new URL("@/assets/onboarding/osos-onboarding-laptop.png", import.meta.url).href
          }
          alt=""
          width="300"
          height="300"
        />
        <LogoStyled width="156" height="36" />
      </Figure>
      <ConfettiExplosion zIndex={9999} />
      <ContentContainer>
        <ResultText
          variant="xlarge"
          type="success"
          weight="semiBold"
          textAlign="center"
        >
          {t("billingOnboarding.result.title")}
        </ResultText>
        <Button onClick={handleOnClose}>
          {t("close", {
            ns: NAMESPACES.COMMON,
          })}
        </Button>
      </ContentContainer>
    </>
  );
}

export default FormResult;
